export default {
  en: {
    'components.2fa-setup-form.action.continue': 'Continue',
    'components.2fa-setup-form.response.success': 'OTP sent.',
    'components.2fa-setup-form.response.failure': '2FA setup request failed.',
  },
};
